import React, { useContext } from 'react';
import { useParams } from 'react-router-dom';
import {
    Container,
    Box,
    Typography,
    TextField,
    CircularProgress,
    Button,
    Stack,
} from '@mui/material';
import {
    ConfigContext,
    useForm,
    http,
} from '../lib';

import { debounce } from 'lodash';

const saveField = debounce(async (data, uri) => {
    await http.put(data, uri);
}, 500);

const onLoad = async ({ values }) => {
    const user = await http.get({}, `${values.config.uri.base}/user/${values._id}`);
    return {
        ...values,
        ...user,
        loading: false,
    };
};

export default function UserDetail() {
    const { userId } = useParams();
    const { config } = useContext(ConfigContext);
    const { state, onChange } = useForm({
        debug: true,
        initialState: {
            config,
            _id: userId,
            firstName: '',
            lastName: '',
            email: '',
            createdAt: null,
            createdBy: '',
            updatedAt: null,
            updatedBy: '',
            deletedAt: null,
            deletedBy: '',
            deleted: false,
            tenantId: '',
            appId: '',
            loading: true
        },
        onLoad
    });

    const handleDelete = async () => {
        await http.delete({}, `${config.uri.base}/user/${state.values._id}`);
        window.location.href = '/users';
    };

    return (
        <Container>
            {state.values.loading ? (
                <CircularProgress />
            ) : (
                <>
                    <Box sx={{ marginTop: '20px' }}>
                        <Typography variant="h5">User Details</Typography>
                        <Stack spacing={2} sx={{ marginTop: '20px' }}>
                            <TextField
                                label="First Name"
                                value={state.values.firstName}
                                onChange={(e) => {
                                    onChange(e.target.value, 'firstName');
                                    saveField({ firstName: e.target.value }, `${config.uri.base}/user/${state.values._id}`);
                                }}
                                fullWidth
                            />
                            <TextField
                                label="Last Name"
                                value={state.values.lastName}
                                onChange={(e) => {
                                    onChange(e.target.value, 'lastName');
                                    saveField({ lastName: e.target.value }, `${config.uri.base}/user/${state.values._id}`);
                                }}
                                fullWidth
                            />
                        </Stack>
                    </Box>
                    <Box sx={{ marginTop: '20px' }}>
                        <Typography variant="h6">Read-Only Fields</Typography>
                        <Stack spacing={2}>
                            <Typography><strong>ID:</strong> {state.values._id}</Typography>
                            <Typography><strong>Email:</strong> {state.values.email}</Typography>
                            <Typography><strong>Created At:</strong> {state.values.createdAt}</Typography>
                            <Typography><strong>Created By:</strong> {state.values.createdBy}</Typography>
                            <Typography><strong>Updated At:</strong> {state.values.updatedAt}</Typography>
                            <Typography><strong>Updated By:</strong> {state.values.updatedBy}</Typography>
                            <Typography><strong>Deleted At:</strong> {state.values.deletedAt}</Typography>
                            <Typography><strong>Deleted By:</strong> {state.values.deletedBy}</Typography>
                            <Typography><strong>Deleted:</strong> {state.values.deleted ? 'Yes' : 'No'}</Typography>
                            <Typography><strong>Tenant ID:</strong> {state.values.tenantId}</Typography>
                            <Typography><strong>App ID:</strong> {state.values.appId}</Typography>
                        </Stack>
                    </Box>
                    <Box sx={{ marginTop: '20px' }}>
                        <Button variant="contained" color="error" onClick={handleDelete}>
                            Delete User
                        </Button>
                    </Box>
                </>
            )}
        </Container>
    );
}
